import { DealType } from './SharedEnums';
import FIMenuPaymentAmount from './FIMenuPaymentAmount'
import financials from '@core/services/financials'
import util from '@core/services/util'
import { reactive } from 'vue';

export default class FIMenuLoanTerm {
    /**
     * The amount for the balloon payment.
     * Setting this to 0 for all deal terms prevents the deal from being treated as balloon.
     */
    balloonAmount?: number = null;
    buyrate?: any = null;
    finalNumbersPerCoverageTerm: any[] = [];
    paymentAmounts?: FIMenuPaymentAmount[] = reactive([]);
    sellrate?: any = null;
    show?: boolean = false;
    term?: any = null;

    constructor(init?: Partial<FIMenuLoanTerm>) {
        if(init){
            this.term = init?.term;
            this.buyrate = init?.buyrate;
            this.sellrate = init?.sellrate;
            this.show = init?.show;
            this.paymentAmounts = init?.paymentAmounts?.map(cttf => new FIMenuPaymentAmount(cttf)) ?? []
            this.balloonAmount = init?.balloonAmount;
            this.finalNumbersPerCoverageTerm = reactive([]);
        }
    }

	isAvailable() {
		return this.term && this.show && util.hasValue(this.buyrate) && util.hasValue(this.sellrate);
	}

	isChoice() {
		return this.term;
	}

	paymentCalculation(dealType: DealType, otd: number, selectedDaysToFirstPayment: number, maxDaysToFirstPayment: number, isBalloon = false) {
		let financePayment: any = 0.0;
		if (dealType === DealType.Retail && this.term) {
			if (isBalloon) {
				financePayment = financials.calculateBalloonPayment(
					this.term,
					otd,
					this.sellrate,
					(selectedDaysToFirstPayment ?? maxDaysToFirstPayment) - 30,
					this.balloonAmount,
				);
			} else {
				financePayment = financials.calculateFinancePayment(this.term, otd, this.sellrate, (selectedDaysToFirstPayment ?? maxDaysToFirstPayment) - 30);
			}
			const financePaymentAtBuyRate = financials.calculateFinancePayment(this.term, otd, this.buyrate, (selectedDaysToFirstPayment ?? maxDaysToFirstPayment) - 30);
			return {
				financePayment,
				paymentAtBuyRate: financePaymentAtBuyRate,
			};
		} else
			return {
				financePayment: null,
				paymentAtBuyRate: null,
			};
	}
}
